import { MCheckbox, ResponsiveFormContainer } from "@app/components";
import React, { useEffect, useMemo, useState } from "react";
import { useFormContext } from "react-hook-form";
import Anexo2Form from "./anexo2";
import Anexo3Form from "./anexo3";
import MailForm from "./mail";
import { anexosOptions } from "../../utils/constants";
import { MODES_OPTIONS } from "@app/types/generics.types";
import { ServiceReport } from "@app/types/report.types";
import { useReport } from "../../utils/useReport";
import { getDefaultValuesReport } from "../../utils/helpers";

interface AnexoCartaProps {
  mode: MODES_OPTIONS;
  idReport?: number;
}
const AnexosCarta = ({ mode, idReport }: AnexoCartaProps) => {
  const form = useFormContext();
  const anexos = form.watch("anexos");
  const isView = mode === MODES_OPTIONS.VIEW;
  const isModal = mode === MODES_OPTIONS.MODAL;
  const [reportPreload, setReportPreload] = useState<
    ServiceReport | undefined
  >();
  const { get } = useReport();

  useEffect(() => {
    const fetchReport = async () => {
      const report = await get(Number(idReport));
      setReportPreload(report);
    };

    idReport && fetchReport();
  }, [idReport]);

  useEffect(() => {
    if (idReport) {
      const defaultValues = getDefaultValuesReport(reportPreload);
      form.reset(defaultValues);
    }
  }, [reportPreload]);

  const setDisabledOptions = useMemo(() => {
    if (isModal) {
      return anexosOptions.map((option) => {
        if (reportPreload && reportPreload[option.value]) {
          return { ...option, disabled: true };
        }
        return option;
      });
    }
    return anexosOptions;
  }, [reportPreload]);

  return (
    <>
      <ResponsiveFormContainer columns={1}>
        <MCheckbox
          key={JSON.stringify(form.getValues("anexos"))}
          name="anexos"
          options={setDisabledOptions}
          multiple={true}
          orientation="horizontal"
          columns={5}
          disabled={isView}
        />
      </ResponsiveFormContainer>

      {anexos?.includes("anexo_2") && (
        <Anexo2Form
          mode={mode}
          disabled={(isModal && reportPreload?.anexo_2) || false}
        />
      )}
      {anexos?.includes("anexo_3") && (
        <Anexo3Form
          mode={mode}
          disabled={(isModal && reportPreload?.anexo_3) || false}
        />
      )}
      {anexos?.includes("letter") && (
        <MailForm
          mode={mode}
          disabled={(isModal && reportPreload?.letter) || false}
        />
      )}
    </>
  );
};

export default AnexosCarta;
